import { render, staticRenderFns } from "./edit.redirects.page.vue?vue&type=template&id=5a982a7c&"
import script from "./edit.redirects.page.vue?vue&type=script&lang=js&"
export * from "./edit.redirects.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports